import { render, staticRenderFns } from "./ModalClaim.vue?vue&type=template&id=50a67348&scoped=true"
import script from "./ModalClaim.vue?vue&type=script&lang=js"
export * from "./ModalClaim.vue?vue&type=script&lang=js"
import style0 from "./ModalClaim.vue?vue&type=style&index=0&id=50a67348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a67348",
  null
  
)

export default component.exports